export default {"src":"/_next/static/media/match-dialog-image.ef8c936a.svg","height":98,"width":98,"blurWidth":0,"blurHeight":0};